import Cookies from 'js-cookie'
import {checkSuccess, getAllSchoolForManager} from "@/api/Apis";
import {SET_SCHOOLS} from "@/store/mutation-types";
import storage from "@/utils/storage";

const app = {
  state: {
    sidebar: {
      opened: !+Cookies.get('sidebarStatus'),
      withoutAnimation: false
    },
    device: 'desktop',
    //刷新后就没有了
    schools:[],
    schoolId:null,
    cur_school_id:0,
    teacherId:null, //当前选中的老师
    teachers:[],
    teachersBySchool:{}, //当前校区的老师  {schoolId:teachers,schoolId:teachers}
    month:null,//当前的月份
  },
  mutations: {
    SET_MONTH: (state, month) => {
      state.month = month;
    },
    SET_SCHOOL_ID: (state, cur_school_id) => {
      state.cur_school_id = cur_school_id;
      state.schoolId = cur_school_id;
    },
    [SET_SCHOOLS]: (state, schools) => {
      storage.set("schools2", schools);
      state.schools = schools;
    },
    SET_TEACHER_ID: (state, teacherId) => {
      state.teacherId = teacherId;
    },
    SET_TEACHERS: (state, teachers) => {
      state.teachers = teachers;
    },
    SET_TEACHERS_BY_SCHOOL: (state, teachers,schoolId) => {
      state.teachersBySchool[schoolId] = teachers;
    },
    TOGGLE_SIDEBAR: state => {
      if (state.sidebar.opened) {
        Cookies.set('sidebarStatus', 1)
      } else {
        Cookies.set('sidebarStatus', 0)
      }
      state.sidebar.opened = !state.sidebar.opened;
      state.sidebar.withoutAnimation = false
    },
    CLOSE_SIDEBAR: (state, withoutAnimation) => {
      Cookies.set('sidebarStatus', 1);
      state.sidebar.opened = false;
      state.sidebar.withoutAnimation = withoutAnimation
    },
    TOGGLE_DEVICE: (state, device) => {
      state.device = device
    }
  },
  actions: {
    GetSchools({ commit }, params){
      getAllSchoolForManager(params).then(res=>{
        if(checkSuccess(res)){
          let schools = res.data.data.schools;
          commit('SET_SCHOOLS', schools);
          commit('SET_SCHOOL_ID',schools.length > 0 ? schools[0].id:null)
        }
      })
    },
    ToggleSideBar: ({ commit }) => {
      commit('TOGGLE_SIDEBAR')
    },
    CloseSideBar({ commit }, { withoutAnimation }) {
      commit('CLOSE_SIDEBAR', withoutAnimation)
    },
    ToggleDevice({ commit }, device) {
      commit('TOGGLE_DEVICE', device)
    }
  }
};

export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js